import { memo, useMemo, type FC, type ReactNode } from 'react';
import { useTheme } from 'styled-components';

import { Tooltip } from '../Tooltip/index.tsx';
import { getIconConfig } from './helpers.ts';
import { FilledIcon, OutlineIcon, IconWrapper } from './styled.ts';
import type { InfoTooltipIconType } from './types.ts';

export interface InfoTooltipIconProps {
  tooltip: string | ReactNode;
  placement?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
  size?: number;
  type?: InfoTooltipIconType;
  dataTestId?: string;
  dataTestIdIcon?: string;
}

export const InfoTooltipIcon: FC<InfoTooltipIconProps> = memo(function InfoTooltipIcon({
  tooltip,
  placement = 'top',
  size = 16,
  type = 'info',
  dataTestId,
  dataTestIdIcon,
}) {
  const { colors } = useTheme();
  const iconConfig = useMemo(() => getIconConfig(type, colors), [type, colors]);

  if (!iconConfig) return null;

  const { Icon, color } = iconConfig;

  return (
    <Tooltip placement={placement} tooltip={tooltip} dataTestId={dataTestId}>
      <IconWrapper data-testid={dataTestIdIcon}>
        <OutlineIcon>
          <Icon size={size} color={color} dataTestId='outlined' />
        </OutlineIcon>
        <FilledIcon>
          <Icon size={size} color={color} filled dataTestId='filled' />
        </FilledIcon>
      </IconWrapper>
    </Tooltip>
  );
});
